










import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class AppButton extends Vue {
  @Prop() message: string;
}
